module.exports = __webpack_public_path__ + "static/media/Icons-20x20-Dropdown-Dropdown 1_up_Black.d2c84068.svg";